<div
   class="d-flex flex-row align-items-center"
   style="margin-bottom: 20px">
   <span>Codes verified: {{ counts.verified }}</span>
   <span class="pl-3">New code requests: {{ counts.newCodeReq }}</span>
   <span class="pl-3">Disable requests: {{ counts.disableReq }}</span>
   <span class="pl-3">Remaining to action: {{ counts.actionNeeded }}</span>
   <button
      pButton
      pRipple
      label="Export"
      class="p-button-success ml-3"
      (click)="onExportToExcel()"
      style="background-color: #1085d2; border-color: #1085d2"></button>
</div>

<div
   class="sort-toggle-container"
   style="display: inline-flex; width: 80%">
   <label for="sortToggle">
      &nbsp;
      <i>Enable Multiple Column Sorting:</i>
   </label>
   <p-toggleswitch
      inputId="sortToggle"
      [(ngModel)]="isMultiSortEnabled"></p-toggleswitch>
</div>

<div
   *ngIf="canAccessProducts"
   style="display: inline-flex; justify-content: end; width: 19.5%; margin-bottom: 10px; margin-right: 5px">
   <button
      pButton
      type="button"
      label="Batch Update Products"
      icon="pi pi-upload"
      (click)="showModal()"></button>

   <p-dialog
      [(visible)]="displayModal"
      [modal]="true"
      [closable]="true"
      [style]="{ width: '50vw' }"
      (onHide)="handleCloseButton()">
      <div style="margin-bottom: 25px">
         <h4 style="margin-bottom: 15px; font-size: 18px; margin-top: -5px">
            Upload a CSV file (in UTF-8 format) to update multiple products to VC products
         </h4>
         <div style="padding: 0px; border-radius: 0px; outline: 1px solid #d7d7d7; outline-offset: -1px; font-size: 13px">
            <input
               type="file"
               (change)="onFileChange($event)"
               accept=".csv" />
         </div>

         <!-- Show loading bar if loading, otherwise show the message -->
         <div
            *ngIf="batchCSCLoading"
            class="batch-loading-bar">
            <p-progressBar mode="indeterminate"></p-progressBar>
         </div>

         <div
            *ngIf="batchSuccessMessage"
            class="batch-success-message"
            style="font-size: 15px; font-weight: 600">
            <p [innerHTML]="batchSuccessMessage"></p>
         </div>

         <div
            *ngIf="batchErrorMessages.length > 0"
            class="batch-success-message">
            <ul style="display: flex; flex-flow: wrap; padding-inline-start: 0px">
               <li
                  *ngFor="let message of batchErrorMessages"
                  style="display: inline-flex; font-size: 13px; line-height: 18px; width: 50%; font-weight: 500; justify-content: stretch">
                  {{ message }}
               </li>
            </ul>
         </div>
      </div>

      <ng-template pTemplate="footer">
         <button
            pButton
            type="button"
            label="Update Products"
            icon="pi pi-refresh"
            [disabled]="!csvUploaded"
            [style.opacity]="csvUploaded ? 1 : 0.5"
            [style.margin-right]="'12px'"
            (click)="updateProducts()"></button>
         <button
            [label]="isUpdateFinished ? 'Close' : 'Cancel'"
            pButton
            type="button"
            icon="pi pi-times"
            (click)="isUpdateFinished ? handleCloseButton() : (displayModal = false)"></button>
      </ng-template>
   </p-dialog>
</div>

<p-table
   #dt
   styleClass="pims-list"
   [value]="rows"
   [virtualScroll]="true"
   [virtualScrollItemSize]="virtualScrollItemSize"
   [virtualScrollOptions]="{ scrollHeight: '100vh' }"
   [multiSortMeta]="multiSortMeta"
   [customSort]="true"
   (sortFunction)="onSort()">
   <ng-template pTemplate="header">
      <tr
         *ngIf="isMultiSortEnabled"
         class="prodMapperHead">
         <th
            *ngIf="showPracticeColumn"
			pSortableColumn="hospitalName"
			(click)="handleSort('hospitalName')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'hospitalName' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'hospitalName' }"
            style="min-width: 210px">
            Hospital
			<p-sortIcon field="hospitalName"></p-sortIcon>
         </th>
         <th
            *ngIf="siteCount > 1"
			pSortableColumn="siteName"
            (click)="handleSort('siteName')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'siteName' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'siteName' }"
            style="width: 150px; padding-left: 12px !important;">
            Site
            <p-sortIcon field="siteName"></p-sortIcon>
         </th>
		 <th
            pSortableColumn="productSKey"
            (click)="handleSort('productSKey')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'productSKey' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'productSKey' }"
            style="width: 100px; padding-left: 12px !important;">
            ID
            <p-sortIcon field="productSKey"></p-sortIcon>
         </th>
         <th
            pSortableColumn="code"
            (click)="handleSort('code')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'code' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'code' }"
            style="min-width: 110px">
            Your Code
            <p-sortIcon field="code"></p-sortIcon>
         </th>
         <th
            pSortableColumn="categoryName"
            (click)="handleSort('categoryName')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'categoryName' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'categoryName' }"
            style="min-width: 140px"
            class="product-list-table">
            Your Category
            <p-sortIcon field="categoryName"></p-sortIcon>
         </th>
         <th
            pSortableColumn="name"
            (click)="handleSort('name')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'name' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'name' }"
            style="min-width: 170px"
            class="product-list-table">
            Your Product Name
            <p-sortIcon field="name"></p-sortIcon>
         </th>
         <!-- <th style="width:100px;"
                pSortableColumn="productTypeSKey">Type <p-sortIcon field="productTypeSKey"></p-sortIcon></th> -->
         <th
            style="width: 120px"
            *ngIf="showPriceColumn"
            pSortableColumn="price"
            (click)="handleSort('price')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'price' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'price' }">
            Price $
            <p-sortIcon field="price"></p-sortIcon>
         </th>
         <th
            class="product-list-table"
            style="min-width: 150px"
            pSortableColumn="ttmRevenue"
            (click)="handleSort('ttmRevenue')"
            [ngClass]="{ 'first-clicked': firstClickedColumn === 'ttmRevenue' }"
            [ngClass]="{ 'second-clicked': secondClickedColumn === 'ttmRevenue' }">
            Trailing 12mo $
            <p-sortIcon field="ttmRevenue"></p-sortIcon>
         </th>
         <!-- <th>Current VC Product</th> -->
         <th>VC Product</th>
         <!-- <th pSortableColumn="doseSize">Dose Size <p-sortIcon field="doseSize"></p-sortIcon></th> -->
         <th></th>
         <th></th>
      </tr>

      <tr
         *ngIf="!isMultiSortEnabled"
         class="prodMapperHead">
         <th
            *ngIf="showPracticeColumn"
			pSortableColumn="hospitalName"
			(click)="singleSort('hospitalName')"
            style="min-width: 210px">
            Hospital
			<p-sortIcon field="hospitalName"></p-sortIcon>
         </th>
		 <th
            *ngIf="siteCount > 1"
			(click)="singleSort('siteName')"
            pSortableColumn="siteName"
            style="width: 150px; padding-left: 12px !important;">
            Site
            <p-sortIcon field="siteName"></p-sortIcon>
         </th>
         <th
            (click)="singleSort('productSKey')"
            pSortableColumn="productSKey"
            style="width: 100px">
            ID
            <p-sortIcon field="productSKey"></p-sortIcon>
         </th>	 
         <th
            (click)="singleSort('code')"
            pSortableColumn="code"
            style="min-width: 110px">
            Your Code
            <p-sortIcon field="code"></p-sortIcon>
         </th>
         <th
            (click)="singleSort('categoryName')"
            pSortableColumn="categoryName"
            style="min-width: 140px"
            class="product-list-table">
            Your Category
            <p-sortIcon field="categoryName"></p-sortIcon>
         </th>
         <th
            (click)="singleSort('name')"
            pSortableColumn="name"
            style="min-width: 170px"
            class="product-list-table">
            Your Product Name
            <p-sortIcon field="name"></p-sortIcon>
         </th>
         <!-- <th style="width:100px;"
                pSortableColumn="productTypeSKey">Type <p-sortIcon field="productTypeSKey"></p-sortIcon></th> -->
         <th
            style="width: 120px"
            *ngIf="showPriceColumn"
            (click)="singleSort('price')"
            pSortableColumn="price">
            Price $
            <p-sortIcon field="price"></p-sortIcon>
         </th>
         <th
            class="product-list-table"
            style="min-width: 150px"
            (click)="singleSort('ttmRevenue')"
            pSortableColumn="ttmRevenue">
            Trailing 12mo $
            <p-sortIcon field="ttmRevenue"></p-sortIcon>
         </th>
         <!-- <th>Current VC Product</th> -->
         <th>VC Product</th>
         <!-- <th pSortableColumn="doseSize">Dose Size <p-sortIcon field="doseSize"></p-sortIcon></th> -->
         <th></th>
         <th></th>
      </tr>
   </ng-template>
   <ng-template
      pTemplate="body"
      let-product>
      <tr [style]="virtualScrollItemSize ? 'height:' + virtualScrollItemSize + 'px' : ''">
         <td *ngIf="showPracticeColumn">{{ product.practice?.nameId }}</td>
         <td *ngIf="siteCount > 1" style="width: 150px; padding-left: 12px !important;">{{ product.siteName }}</td>
		 <td style="width: 100px">{{ product.productSKey }}</td>
         <td style="width: 100px">{{ product.code }}</td>
         <td>{{ product.categoryName }}</td>
         <ng-template #pimsProductView>
            <div [style]="pimsProductEditable ? 'cursor: pointer;' : ''">
               <span
                  *ngIf="product.mappingScore == 100 && product?.vcProductSKey != -1"
                  class="badge badge-primary">
                  Verified
               </span>
               <span
                  *ngIf="product.mappingScore !== 100 && !product.notNeeded && !!product.reasonOfAdd"
                  class="badge badge-success">
                  New Code Request
               </span>
               <span
                  *ngIf="product.mappingScore !== 100 && product.notNeeded"
                  class="badge badge-danger">
                  Disable Request
               </span>
               <span
                  *ngIf="product.mappingScore !== 100 && !product.notNeeded && !product.reasonOfAdd"
                  class="badge badge-warning">
                  Action Needed
               </span>
               <i
                  class="fa fa-check text-success pl-2"
                  title="Confirmed"
                  *ngIf="product?.productSKey && product?.vcProductSKey > 0 && product?.mappingScore == 100"></i>
               <i
                  *ngIf="
                     product?.productSKey &&
                     ((product?.mappingScore && product.mappingScore < 60) ||
                        (product.vcProduct && product.vcProduct?.vcProductCategorySKey !== product.vcProductCategorySKey))
                  "
                  [pTooltip]="'This may not be mapped correctly.'"
                  class="pi pi-exclamation-triangle pl-2"
                  style="vertical-align: text-bottom"
                  tooltipStyleClass="pims-tooltip"></i>

               <span
                  *ngIf="canDoSameMap && getSameMapCount(product.vcProductSKey) > 1"
                  style="
                     vertical-align: text-bottom;
                     cursor: pointer;
                     font-weight: 700;
                     font-size: 10px;
                     margin-left: 8px;
                     color: #ffc107;
                     border-radius: 100%;
                     text-align: center;
                     border: 1.5px solid #ffc107;
					 width: 17px;
                     height: 17px;
                     line-height: 14px;
                     display: inline-block;
                  "
                  [pTooltip]="
                     'The following products are also mapped to this central product: ' + getProductNamesTooltip(product.vcProductSKey, product.name)
                  "
                  [attr.data-count]="getSameMapCount(product.vcProductSKey) || 0"
                  tooltipStyleClass="pims-tooltip">
                  !
               </span>

               <i
                  *ngIf="product?.vcProductUnlinked && product?.notNeeded"
                  [pTooltip]="'Not needed'"
                  class="pi pi-eye-slash pl-2"
                  tooltipStyleClass="pims-tooltip"></i>
               <br />
               <span *ngIf="product && product.name">{{ product.name }}</span>

               <span
                  *ngIf="pimsProductEditable && (!product || !product.name)"
                  style="color: gray">
                  Select a product
               </span>
               <i
                  *ngIf="pimsProductEditable"
                  class="fa fa-pencil px-2"></i>
            </div>
         </ng-template>
         <td *ngIf="!pimsProductEditable">
            <ng-container *ngTemplateOutlet="pimsProductView"></ng-container>
         </td>
         <td
            *ngIf="pimsProductEditable"
            [pEditableColumn]="product.name">
            <p-cellEditor>
               <ng-template pTemplate="input">
                  <vc-product-tree-select
                     class="w-100"
                     [pimsProduct]="product"
                     [initialValue]="product.productSKey"
                     [allProducts]="(getHierarchicalPracticeProducts(product.practiceSKey) | async) || undefined"
                     (onChanged)="onPIMSProductChanged($event)"></vc-product-tree-select>
               </ng-template>
               <ng-template pTemplate="output">
                  <ng-container *ngTemplateOutlet="pimsProductView"></ng-container>
               </ng-template>
            </p-cellEditor>
         </td>
         <!-- <td style="width:100px;">
                <span *ngIf="product.productType == 1"
                      class="badge badge-primary">Product</span>
                <span *ngIf="product.productType == 2"
                      class="badge badge-secondary">Service</span>
            </td> -->
         <td
            style="width: 120px"
            *ngIf="showPriceColumn">
            {{ product.price | currency }}
         </td>
         <td style="width: 150px">
            {{ product.ttmRevenue | currency }}
         </td>
         <td
            style="width: 450px"
            [pEditableColumn]="product.vcProduct?.name">
            <p-cellEditor>
               <ng-template pTemplate="input">
                  <vc-product-tree-select
                     class="w-100"
                     [pimsProduct]="product"
                     [initialValue]="product.vcProductUnlinked == false ? product.vcProductSKey : undefined"
                     [allProducts]="(hierarchicalProducts$ | async) || undefined"
                     [useCustomFilter]="true"
                     (onChanged)="onVCProductChanged($event)"></vc-product-tree-select>
               </ng-template>
               <ng-template pTemplate="output">
                  <div style="cursor: pointer">
                     <ng-container *ngIf="product.vcProduct?.name && product.vcProductUnlinked == false">
                        <span *ngIf="product.vcProduct?.vcProductCategory">{{ product.vcProduct?.vcProductCategory?.name }} ></span>
                        {{ product.vcProduct?.name }}
                     </ng-container>
                     <span
                        *ngIf="!product.vcProduct?.name || product.vcProductUnlinked == true"
                        style="color: gray">
                        Select a product
                     </span>
                     <i class="fa fa-pencil px-2"></i>
                  </div>
               </ng-template>
            </p-cellEditor>
            <i>
               <span *ngIf="product && product.vcProductUnlinked == true && product.vcProduct?.name">
                  Previously Mapped: {{ product.vcProduct?.name }}
               </span>
            </i>
         </td>
         <!-- <td [pEditableColumn]="product.doseSize">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <p-inputNumber pTooltip='Enter the dose size of the product. For example, if you are mapping from PIMS "Apoquel 30 count" to VC "Apoquel single", set the dose size to 30.'
                                       inputId="doseSize"
                                       [style]="{'width':'100px'}"
                                       [inputStyle]="{'width':'100px'}"
                                       mode="decimal"
                                       [ngModel]="product.doseSize"
                                       [maxFractionDigits]="3"
                                       (onBlur)="onDoseSizeChange({pimsProduct:product, doseSize:$event.target.value})"
                                       min="0.111"> </p-inputNumber>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div style="cursor: pointer;"
                             pTooltip='Enter the dose size of the product. For example, if you are mapping from PIMS "Apoquel 30 count" to VC "Apoquel single", set the dose size to 30.'>
                            <span *ngIf="product && product.doseSize">{{
                                product.doseSize }}</span>
                            <span *ngIf="!product?.doseSize"
                                  style="color:gray">Enter the dose size</span>
                            <i class="fa fa-pencil px-2"></i>
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td> -->

         <!--<ng-container [ngModel]="getNotesCount(product.productSKey)"></ng-container >-->

         <td
            style="width: 240px; min-width: 130px; text-align: right; padding-right: 5px !important"
            class="product-list-table-buttons">
            <p-button
               *ngIf="product.vcProductSKey > 0 && product.productSKey > 0 && !product.vcProductUnlinked"
               title="Unlink"
               class="px-1 new unlink"
               size="small"
               (onClick)="onUnlink(product)">
               <i
                  class="fa fa-unlink"
                  style="padding: 5px 0px"
                  alt="Unlink"></i>
            </p-button>
            <p-button
               *ngIf="product.vcProductUnlinked"
               title="Re-Link"
               class="px-1 new relink"
               id="relinkButton-{{ product.productSKey }}"
               size="small"
               (onClick)="clickedProdSKey = product.productSKey; onRelink(product)">
               <i
                  class="fa fa-link"
                  style="padding: 5px 0px"
                  alt="Link"></i>
            </p-button>
            <p-button
               *ngIf="product.vcProductUnlinked && product.mappingScore !== 100"
               title="Clear"
               class="px-1 new clear"
               id="clearAllButton-{{ product.productSKey }}"
               size="small"
               (onClick)="clickClearButton(product); product.vcProduct.name = null">
               <i
                  class="fa fa-undo-alt"
                  style="padding: 5px 0px"
                  alt="Clear"></i>
            </p-button>
            <p-button
               *ngIf="product.vcProductSKey > 0 && product.productSKey > 0 && product.mappingScore !== 100 && !product.vcProductUnlinked"
               title="Mark this mapping as verified"
               class="px-1 new verify"
               size="small"
               (onClick)="onVCProductChanged({ pimsProduct: product, newValue: product.vcProductSKey })">
               <i
                  class="fa fa-check"
                  style="padding: 5px 0px"
                  alt="Verify"></i>
            </p-button>
            <p-button
               *ngIf="product.vcProductSKey > 0 && product.productSKey > 0 && product.mappingScore == 100"
               title="Mark this to be unverified"
               class="px-1 new unverify"
               size="small"
               (onClick)="onVcProductUnverify(product)">
               <i
                  class="fa fa-ban"
                  style="padding: 5px 0px"
                  alt="Unverify"></i>
            </p-button>
            <p-button
               title="Notes"
               [class.px-1]="true"
               [class.notification]="true"
               [class.hasNotes]="getNotesCount(product.productSKey) > 0 && getNotesCount(product.productSKey) != 99"
               [class.hasNotesOnlyInfo]="getNotesCount(product.productSKey) == 99"
               size="small"
               (onClick)="openNotesModal(product.productSKey)"
               [attr.data-count]="getNotesCount(product.productSKey)">
               <i
                  class="fa fa-bell"
                  style="padding: 5px 0px; color: transparent; -webkit-text-stroke-width: 2px; -webkit-text-stroke-color: white"
                  alt="Notifications"></i>
            </p-button>
            <button
               id="notesModalButton"
               data-bs-toggle="modal"
               data-bs-target="#notesModal"
               style="display: none"></button>
         </td>
         <td>
            <i
               class="fa fa-spin fa-circle-notch"
               *ngIf="product.isSaving === true"></i>
            <i
               class="fa fa-check text-success"
               title="Saved"
               *ngIf="product.isSaving !== true && product.savedSuccessfully"></i>
            <i
               class="fa fa-x text-danger"
               title="Not saved"
               *ngIf="product.savedSuccessfully === false"></i>
         </td>
      </tr>
   </ng-template>
   <ng-template pTemplate="emptymessage">
      <tr>
         <td colspan="10">No results found.</td>
      </tr>
   </ng-template>
</p-table>
<p-dialog
   header="Unlink product"
   [(visible)]="unlinkDialogShown"
   [modal]="true"
   [style]="{ width: '50vw' }"
   [draggable]="false"
   [resizable]="false">
   <div class="row">
      <div class="col-md-12">
         <label class="form-label">Have you tried searching for the Vetcor item this product/service should be linked to?</label>
         <p-selectButton
            [options]="selectOptions"
            [(ngModel)]="triedSearching"
            optionLabel="label"
            optionValue="value"></p-selectButton>
      </div>
      <div
         class="col-md-12 pt-2"
         *ngIf="triedSearching === false">
         You can click the pencil icon under Vetcor Product/Service to pick a different mapping.
      </div>
   </div>
   <div
      class="row"
      *ngIf="triedSearching === true">
      <div class="col-md-12 pt-2">
         <label class="form-label">Is this code used in your practice?</label>
         <p-selectButton
            [options]="selectOptions"
            [(ngModel)]="isThisCodeUsed"
            optionLabel="label"
            optionValue="value"></p-selectButton>
      </div>
   </div>
   <div
      class="row"
      *ngIf="triedSearching === true && isThisCodeUsed == true">
      <div class="col-md-12 pt-2">
         <label class="form-label">Why do you want to add the missing product?</label>
         <input
            type="text"
            pInputText
            inputId="reasonOdAdd"
            class="w-100"
            [style]="{ width: '100%' }"
            [(ngModel)]="reasonOfAdd" />
      </div>
   </div>
   <ng-template pTemplate="footer">
      <p-button
         icon="pi pi-times"
         (click)="cancelUnlink()"
         label="Cancel"
         class="px-2"
         styleClass="p-button-danger p-button-text"></p-button>
      <p-button
         *ngIf="triedSearching && ((isThisCodeUsed && reasonOfAdd) || isThisCodeUsed == false)"
         icon="pi pi-check"
         (click)="doTheUnlink()"
         label="Unlink"
         styleClass="p-button-text"></p-button>
   </ng-template>
</p-dialog>

<p-dialog
   header="This code has already been mapped..."
   [(visible)]="sameMapDialogShown"
   [modal]="true"
   [style]="{ width: '50vw', 'z-index': '1050' }"
   [draggable]="false"
   [resizable]="false">
   <div class="row">
      <div class="col-md-12 pt-2">
         <label class="form-label">Please explain why these should be mapped to the same central product and any pricing differences.</label>
         <input
            type="text"
            pInputText
            inputId="reasonSameMapping"
            class="w-100"
            [style]="{ width: '100%' }"
            [(ngModel)]="reasonSameMapping" />
      </div>
   </div>
   <ng-template pTemplate="footer">
      <p-button
         icon="pi pi-times"
         (click)="cancelSameMap()"
         label="Cancel"
         class="px-2"
         styleClass="p-button-danger p-button-text"></p-button>
      <p-button
         icon="pi pi-check"
         (click)="doTheSameMap()"
         label="Submit"
         styleClass="p-button-text"></p-button>
   </ng-template>
</p-dialog>

<div
   class="modal custom-modal fade modal-padding"
   id="notesModal"
   role="dialog">
   <div
      class="modal-dialog modal-dialog-centered"
      style="width: 1000px; min-width: 1000px">
      <div
         class="modal-content"
         style="width: 900px; min-width: 100px">
         <div class="modal-header header-border align-items-center justify-content-between p-0">
            <h5 class="modal-title">Notifications</h5>
            <button
               type="button"
               class="btn-close position-static"
               data-bs-dismiss="modal"
               aria-label="Close"
               style="padding-bottom: 4px">
               <span aria-hidden="true">×</span>
            </button>
         </div>
         <div
            class="modal-body p-0"
            style="position: relative">
            <vc-spinner *ngIf="loadingMapNotes"></vc-spinner>
            <span *ngIf="!loadingMapNotes">
               <div
                  *ngFor="let productMapNote of productMapNotes; let isFirst = first; let isLast = last"
                  class="calls-box">
                  <div
                     *ngIf="isLast"
                     class="calls-action"
                     style="display: inline-block; align-items: center; float: right; position: absolute; top: 10px; right: 0px">
                     <span
                        *ngIf="productMapNote.action == 0"
                        class="openBadge">
                        <i
                           *ngIf="productMapNote.action == 0"
                           class="fa fa-folder-open"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Open
                     </span>
                     <span
                        *ngIf="productMapNote.action == 1"
                        class="moreInfoBadge">
                        <i
                           *ngIf="productMapNote.action == 1"
                           class="fa fa-exclamation"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Need More Information
                     </span>
                     <span
                        *ngIf="productMapNote.action == 2"
                        class="declinedBadge">
                        <i
                           *ngIf="productMapNote.action == 2"
                           class="la la-remove"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Declined
                     </span>
                     <span
                        *ngIf="productMapNote.action == 3"
                        class="approvedBadge">
                        <i
                           *ngIf="productMapNote.action == 3"
                           class="fa fa-check"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Approved
                     </span>
                  </div>

                  <div
                     *ngIf="isFirst"
                     class="calls-box"
                     style="margin-bottom: 30px">
                     <div class="reply-box">
                        <div
                           class="calls-user"
                           style="display: inline-flex; align-items: center">
                           <i class="notesUser fa fa-user"></i>
                           <div>
                              <h6 style="font-size: 15px; font-weight: 500; margin-bottom: 0px; color: #373b3e">User</h6>
                              <p style="font-size: 14px; margin-bottom: 0px">{{ productMapNote.timestamp | date : "M/d/yyyy h:mm a" }}</p>
                           </div>
                        </div>
                        <p style="margin-bottom: 15px; margin-top: 15px; font-size: 14px">
                           <span [innerHTML]="productMapNote.feedback"></span>
                        </p>
                     </div>
                  </div>

                  <div
                     *ngIf="productMapNote.isAdmin == 1 && !isFirst"
                     class="caller-info"
                     style="background: #f9f9f9; border-radius: 5px; margin: 0 0 15px; padding: 15px; margin-left: 40px">
                     <div
                        class="calls-user"
                        style="display: inline-flex; align-items: center">
                        <i class="notesUser fa fa-hospital-user"></i>
                        <div>
                           <h6 style="font-size: 15px; font-weight: 500; margin-bottom: 0px; color: #373b3e">Admin</h6>
                           <p style="font-size: 14px; margin-bottom: 0px">{{ productMapNote.timestamp | date : "M/d/yyyy h:mm a" }}</p>
                        </div>
                     </div>
                     <p style="font-size: 14px; margin-bottom: 15px; margin-top: 15px">
                        <span [innerHTML]="productMapNote.feedback"></span>
                     </p>
                  </div>

                  <div
                     *ngIf="productMapNote.isAdmin == 0 && !isFirst"
                     class="reply-box"
                     style="margin-bottom: 20px; margin-left: 55px">
                     <p style="margin-bottom: 10px; font-size: 14px">
                        <span [innerHTML]="productMapNote.feedback"></span>
                     </p>
                     <p style="margin-bottom: 10px; font-size: 14px">
                        <i
                           class="notesUser fa fa-user"
                           style="font-size: 12px; height: 25px; width: 25px; line-height: 24px"></i>
                        <i>User responded on {{ productMapNote.timestamp | date : "M/d/yyyy h:mm a" }}</i>
                     </p>
                  </div>
               </div>

               <div
                  class="notes-editor"
                  style="margin-left: 40px">
                  <div
                     *ngIf="showCommentBox"
                     class="note-edit-wrap"
                     style="display: block">
                     <textarea
                        [(ngModel)]="userFeedback"
                        class="form-control form-control-sm adminFeedback"
                        rows="3"
                        placeholder="Enter feedback"
                        style="margin-bottom: 15px; height: 120px"></textarea>

                     <div
                        class="text-end note-btns"
                        style="margin-top: 5px; text-align: right !important">
                        <a
                           href="javascript:void(0);"
                           class="btn btn-lighter add-cancel"
                           style="
                              margin: 10px 10px 0 0;
                              padding: 7px 15px;
                              background-color: #f5f6f7;
                              border: 1px solid #f5f6f7;
                              color: #373b3e !important;
                              border-radius: 5px;
                              padding: 7px 15px;
                              font-size: 15px;
                              font-weight: 500;
                           "
                           (click)="toggleCommentBox()">
                           Cancel
                        </a>
                        <a
                           href="javascript:void(0);"
                           class="btn btn-primary"
                           (click)="addSupportNote()"
                           data-bs-dismiss="modal"
                           style="margin: 10px 10px 0 0; padding: 7px 15px; line-height: 20px">
                           Save
                        </a>
                     </div>
                  </div>
                  <div
                     class="text-end"
                     *ngIf="!showCommentBox"
                     style="text-align: right !important">
                     <a
                        href="javascript:void(0);"
                        *ngIf="showCommentLink"
                        class="add-comment"
                        (click)="toggleCommentBox()"
                        style="font-size: 14px; font-weight: 500; display: inline-flex; align-items: center">
                        <i
                           class="las la-plus-circle me-1"
                           style="margin-right: 0.25rem !important"></i>
                        Add Comment
                     </a>
                  </div>
               </div>
            </span>
         </div>
      </div>
   </div>
</div>
